module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step03_73101924d9ffcf86b50ffe53fd76fdf8.png";